// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("GOLSansDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("GOLSansDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("GOLSansDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("GOLSansDisplay-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Nunito-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Nunito-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Nunito-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("NunitoSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("NunitoSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("NunitoSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("NunitoSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 500;
}

@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'GOL Sans Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 600;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 500;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: 600;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
  font-weight: 500;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'Nunito Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-assets/dist/fonts/tgr-fonts.css"],"names":[],"mappings":";AACA;EACE,+BAA+B;EAC/B,+DAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,+DAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,+DAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,+DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+DAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+DAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gEAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gEAAsD;EACtD,gBAAgB;AAClB","sourcesContent":["\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('GOLSansDisplay-Bold.ttf') format('truetype');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('GOLSansDisplay-Medium.ttf') format('truetype');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('GOLSansDisplay-Regular.ttf') format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'GOL Sans Display';\n  src: url('GOLSansDisplay-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('Nunito-Bold.ttf') format('truetype');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('Nunito-Medium.ttf') format('truetype');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('Nunito-Regular.ttf') format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('Nunito-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('NunitoSans-Bold.ttf') format('truetype');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('NunitoSans-Medium.ttf') format('truetype');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('NunitoSans-Regular.ttf') format('truetype');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('NunitoSans-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
